import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

/** Slim gradient bar pinned to the top of the viewport, filling with scroll depth. */
const ScrollProgress: React.FC = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 200, damping: 32, mass: 0.2 });

  return (
    <motion.div
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: 3,
        transformOrigin: '0% 50%', scaleX,
        background: 'linear-gradient(90deg, #005B66, #0B7078, #D62828)',
        zIndex: 2000, pointerEvents: 'none',
      }}
    />
  );
};

export default ScrollProgress;
